export default __webpack_public_path__ + "static/media/ic-no-coupons.7829d11e.svg";